import { v4 } from 'uuid'
import { FIGHT_CATEGORY_ID } from 'web/data/general/id'
import { Fight, FightEvent, FightEventFlag, FightSegment, SetupFightEvent } from 'web/data/models'
import { ISODate } from 'web/utils/time-utils'
import { emptyStringAsUndefined } from 'web/utils/utils'

type NewFight = {
    fightId?: string
    note?: string
    fightName: string
    fightCategoryId: string
}

type NewSegment = {
    fightId: string
    name: string
    userCreated: boolean
    offset: number
    condition?: string
}

type NewEvent = {
    fightSegmentId: string
    name: string

    /**
     * Set to true for events the user can edit
     */
    userCreated: boolean

    /**
     * Relative to fight 00:00
     */
    fightOffset: number

    flags: FightEventFlag[]
}

type NewSetupEvent = NewEvent & {
    setupId: string
}

/**
 * Wraps creation of outline objects.
 */
export class OutlineFactory {

    public static createFight({
        fightCategoryId,
        fightName,
        fightId,
        note
    }: NewFight): Fight {
        return {
            id: fightId ?? v4(),
            name: fightName,
            note: note ?? "",

            categoryId: emptyStringAsUndefined(fightCategoryId)
                ?? FIGHT_CATEGORY_ID.CUSTOM.Uncategorized,

            createdAt: ISODate(),
            updatedAt: ISODate(),
        }
    }

    public static createSegment({
        fightId,
        name,
        offset,
        userCreated,
        condition
    }: NewSegment): FightSegment {
        return {
            id: v4(),
            fightId,
            name,
            userCreated,
            offset,
            condition
        }
    }

    public static createEvent({
        fightOffset,
        fightSegmentId,
        name,
        userCreated,
        flags
    }: NewEvent): FightEvent {
        return {
            fightSegmentId,
            userCreated,
            id: v4(),
            offset: fightOffset,
            name,
            comment: "",
            flags: flags
        }
    }

    public static createSetupEvent({
        fightOffset,
        fightSegmentId,
        name,
        userCreated,
        setupId
    }: NewSetupEvent): SetupFightEvent {
        return {
            fightSegmentId,
            userCreated,
            id: v4(),
            offset: fightOffset,
            name,
            comment: "",
            flags: [],
            setupId
        }
    }

}
